import Icon from "@mui/icons-material/AccountBalanceWallet";
import BankTallyExportPage from "./BankTallyExportPage";

export default {
  list: BankTallyExportPage,
  icon: Icon,
  label: "Bank → Tally export",
  options: { label: "Bank → Tally export" },
  name: "bankTallyExport",
};
